import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row lockHeader shinseisyoHeader" }
const _hoisted_2 = { class: "subheader col-md-6" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = {
  key: 0,
  class: "badge badge-dark fw-400 l-h-n"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-info fw-400 l-h-n"
}
const _hoisted_6 = {
  key: 2,
  class: "badge badge-success fw-400 l-h-n"
}
const _hoisted_7 = {
  key: 3,
  class: "badge badge-danger fw-400 l-h-n"
}
const _hoisted_8 = {
  class: "subheader-block ml-auto demo col-md-6",
  style: {"text-align":"right"}
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_15 = { class: "d-flex flex-start w-100" }
const _hoisted_16 = { class: "d-flex flex-fill" }
const _hoisted_17 = { class: "flex-fill" }
const _hoisted_18 = { class: "m-0" }
const _hoisted_19 = {
  key: 1,
  class: "alert alert-primary"
}
const _hoisted_20 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_21 = {
  key: 3,
  class: "alert alert-primary"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-xl-12" }
const _hoisted_24 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_25 = { class: "panel-container show" }
const _hoisted_26 = { class: "panel-content contents" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-5 contCnt" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-5 contCnt" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-5 contCnt" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-5 contCnt" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-5 contCnt" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-5 contCnt" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-5 contCnt" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-5 contCnt" }
const _hoisted_45 = {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px","margin-bottom":"0"}
}
const _hoisted_46 = { class: "col contCnt" }
const _hoisted_47 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "custom-control custom-radio custom-control-inline mb-3" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_59 = {
  key: 0,
  class: "error-message4vali error_addchg_type"
}
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-5 contCnt" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-5 contCnt" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_66 = {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px","margin-bottom":"0"}
}
const _hoisted_67 = { class: "col contTitle" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-md-5 contCnt" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-md-5 contCnt" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-md-5 contCnt" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-12 contCnt" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-5 contCnt" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-md-5 contCnt" }
const _hoisted_82 = ["disabled"]
const _hoisted_83 = {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px","margin-bottom":"0"}
}
const _hoisted_84 = { class: "col contTitle" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-md-5 contCnt" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-5 contCnt" }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-md-5 contCnt" }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-md-12 contCnt" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-md-5 contCnt" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "col-md-5 contCnt" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-md-5 contCnt" }
const _hoisted_102 = { class: "row" }
const _hoisted_103 = { class: "col-md-5 contCnt" }
const _hoisted_104 = ["value"]
const _hoisted_105 = { class: "col-md-5 contCnt" }
const _hoisted_106 = ["value"]
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col-md-5 contCnt" }
const _hoisted_109 = { class: "row" }
const _hoisted_110 = { class: "col-md-5 contCnt" }
const _hoisted_111 = ["value"]
const _hoisted_112 = { class: "col-md-5 contCnt" }
const _hoisted_113 = ["value"]
const _hoisted_114 = { class: "row" }
const _hoisted_115 = { class: "col-md-5 contCnt" }
const _hoisted_116 = { class: "row" }
const _hoisted_117 = { class: "col-md-5 contCnt" }
const _hoisted_118 = ["value"]
const _hoisted_119 = { class: "col-md-5 contCnt" }
const _hoisted_120 = ["value"]
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col contCnt" }
const _hoisted_123 = { class: "demo" }
const _hoisted_124 = { class: "table table-sm m-0 tableTsukin" }
const _hoisted_125 = { class: "text-success fw-500" }
const _hoisted_126 = { class: "modal-footer" }
const _hoisted_127 = { class: "modal-footer" }
const _hoisted_128 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_addchg_row = _resolveComponent("Mo_addchg_row")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", {
    id: "js-page-content",
    role: "main",
    class: _normalizeClass(["page-content", {
      isEdit: _ctx.isEditMode,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _cache[30] || (_cache[30] = _createTextVNode(" 住所変更及び通勤手当申請書 ")),
          (_ctx.delegate.request.c_request_status == 4)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_4, "取下"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 1)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_5, "申請中"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 3)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_6, "承認済"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 2)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_7, "差戻"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.delegate.request.c_request_status != 2 && _ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dl()))
            }, _cache[31] || (_cache[31] = [
              _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
              _createTextVNode("Excel出力 ")
            ]), 8, _hoisted_9))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
            }, _cache[32] || (_cache[32] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("登録 ")
            ]), 8, _hoisted_10))
          : _createCommentVNode("", true),
        (
            _ctx.isEditMode &&
            (_ctx.isAdmin || _ctx.isMine) &&
            _ctx.delegate.request.c_request_status != 4
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disableConf()))
            }, _cache[33] || (_cache[33] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("取下 ")
            ]), 8, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.isEditMode && _ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.delConf()))
            }, _cache[34] || (_cache[34] = [
              _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
              _createTextVNode("削除 ")
            ]), 8, _hoisted_12))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/shinseisyolist')))
        }, _cache[35] || (_cache[35] = [
          _createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1),
          _createTextVNode("戻る ")
        ]), 8, _hoisted_13)
      ])
    ]),
    _cache[92] || (_cache[92] = _createElementVNode("div", { class: "lockHeaderSpacer" }, "　", -1)),
    (_ctx.fmShowConf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
              _createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                _createElementVNode("i", { class: "fal fa-info-circle" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "h5" }, "あなたが承認者です", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("p", null, " この申請書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。 ", -1)),
                _createElementVNode("p", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.upd4Approval(true)))
                  }, _cache[36] || (_cache[36] = [
                    _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
                    _createTextVNode("承認 ")
                  ])),
                  _cache[38] || (_cache[38] = _createElementVNode("span", { style: {"width":"20px"} }, " 　", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger waves-effect waves-themed",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.upd4Approval(false)))
                  }, _cache[37] || (_cache[37] = [
                    _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
                    _createTextVNode("差戻 ")
                  ]))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowConfEx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[42] || (_cache[42] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-4340e145><div class=\"mr-2 hidden-md-down\" data-v-4340e145><span class=\"icon-stack icon-stack-lg\" data-v-4340e145><i class=\"fal fa-info-circle\" data-v-4340e145></i></span></div><div class=\"d-flex flex-fill\" data-v-4340e145><div class=\"flex-fill\" data-v-4340e145><span class=\"h5\" data-v-4340e145>この申請書は承認依頼中です</span><p data-v-4340e145> この申請書は承認依頼中です。お急ぎの場合は、承認者にご連絡ください。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.fmShowSasimodosi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[43] || (_cache[43] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-4340e145><div class=\"mr-2 hidden-md-down\" data-v-4340e145><span class=\"icon-stack icon-stack-lg\" data-v-4340e145><i class=\"fal fa-info-circle\" data-v-4340e145></i></span></div><div class=\"d-flex flex-fill\" data-v-4340e145><div class=\"flex-fill\" data-v-4340e145><span class=\"h5\" data-v-4340e145>この申請書は差し戻しされました</span><p data-v-4340e145> この申請書は承認権者により差し戻しされています。差し戻し理由を確認の上、再度新しく申請書を作成してください。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.fmShowTorisage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[44] || (_cache[44] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-4340e145><div class=\"mr-2 hidden-md-down\" data-v-4340e145><span class=\"icon-stack icon-stack-lg\" data-v-4340e145><i class=\"fal fa-info-circle\" data-v-4340e145></i></span></div><div class=\"d-flex flex-fill\" data-v-4340e145><div class=\"flex-fill\" data-v-4340e145><span class=\"h5\" data-v-4340e145>この申請書は取り下げられました</span><p data-v-4340e145> この申請書は申請者により取り下げられています。管理権限者はこの申請書を削除する事ができます。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _cache[82] || (_cache[82] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "申請時用"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_25, [
            _cache[81] || (_cache[81] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請番号", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaCd",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delegate.request.c_request_id) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.delegate.request.c_request_id]
                      ])
                    ]),
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "管理名", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "xxxx案件でyyyy作業の為",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delegate.request.c_request_name) = $event))
                      }, null, 8, _hoisted_35), [
                        [_vModelText, _ctx.delegate.request.c_request_name]
                      ])
                    ]),
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請日時", -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.convDateTime(_ctx.delegate.request.c_request_datetime)
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_40)
                    ]),
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請者", -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      (_ctx.isAdmin && !_ctx.isEditMode)
                        ? (_openBlock(), _createBlock(_component_vSelect, {
                            key: 0,
                            options: _ctx.getOpStaffs(),
                            label: "c_staff_name",
                            modelValue: _ctx.delegate.request.c_staff_id,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.request.c_staff_id) = $event)),
                            reduce: (label) => label.c_staff_id
                          }, null, 8, ["options", "modelValue", "reduce"]))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            name: "txtKouzaCd",
                            class: "form-control form-control-sm",
                            disabled: "",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.domApplicantName) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.domApplicantName]
                          ])
                    ]),
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "種類", -1)),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "jushoNew",
                      name: "radioJusho",
                      value: "1",
                      disabled: _ctx.isEditMode,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.delegate.c_request_addchg_type) = $event))
                    }, null, 8, _hoisted_48), [
                      [_vModelRadio, _ctx.delegate.c_request_addchg_type]
                    ]),
                    _cache[57] || (_cache[57] = _createElementVNode("label", {
                      class: "custom-control-label",
                      for: "jushoNew"
                    }, "新規", -1))
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "jushoUpd",
                      name: "radioJusho",
                      value: "2",
                      disabled: _ctx.isEditMode,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.delegate.c_request_addchg_type) = $event))
                    }, null, 8, _hoisted_50), [
                      [_vModelRadio, _ctx.delegate.c_request_addchg_type]
                    ]),
                    _cache[58] || (_cache[58] = _createElementVNode("label", {
                      class: "custom-control-label",
                      for: "jushoUpd"
                    }, "住所変更", -1))
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "tsukinUpd",
                      name: "radioJusho",
                      value: "3",
                      disabled: _ctx.isEditMode,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.delegate.c_request_addchg_type) = $event))
                    }, null, 8, _hoisted_52), [
                      [_vModelRadio, _ctx.delegate.c_request_addchg_type]
                    ]),
                    _cache[59] || (_cache[59] = _createElementVNode("label", {
                      class: "custom-control-label",
                      for: "tsukinUpd"
                    }, "通勤経路の変更", -1))
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "unchinUpd",
                      name: "radioJusho",
                      value: "4",
                      disabled: _ctx.isEditMode,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.delegate.c_request_addchg_type) = $event))
                    }, null, 8, _hoisted_54), [
                      [_vModelRadio, _ctx.delegate.c_request_addchg_type]
                    ]),
                    _cache[60] || (_cache[60] = _createElementVNode("label", {
                      class: "custom-control-label",
                      for: "unchinUpd"
                    }, "運賃改定", -1))
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "jushoSonota",
                      name: "radioJusho",
                      value: "5",
                      disabled: _ctx.isEditMode,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.delegate.c_request_addchg_type) = $event))
                    }, null, 8, _hoisted_56), [
                      [_vModelRadio, _ctx.delegate.c_request_addchg_type]
                    ]),
                    _cache[61] || (_cache[61] = _createElementVNode("label", {
                      class: "custom-control-label mr-3",
                      for: "jushoSonota"
                    }, "その他", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "col form-control form-control-sm",
                      id: "jushoSonota",
                      disabled: _ctx.isEditMode,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.domAddchg_type_oth) = $event))
                    }, null, 8, _hoisted_57), [
                      [_vModelText, _ctx.domAddchg_type_oth]
                    ]),
                    (_ctx.errors?.path === 'addchg_type_oth')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.errors.message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.errors?.path === 'addchg_type')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "通勤開始・変更年月日", -1)),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        maxlength: "10",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.domAddchg_start) = $event))
                      }, null, 8, _hoisted_64), [
                        [_vModelText, _ctx.domAddchg_start]
                      ]),
                      (_ctx.errors?.path === 'addchg_start')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[69] || (_cache[69] = _createElementVNode("h3", null, [
                    _createElementVNode("span", { class: "badge bg-primary-400 p-2 jushoTitle" }, "現住所")
                  ], -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _cache[66] || (_cache[66] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "郵便番号", -1)),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtKouzaNumber",
                            class: "form-control form-control-sm",
                            disabled: _ctx.isEditMode,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.delegate.c_request_addchg_cr_zip) = $event))
                          }, null, 8, _hoisted_72), [
                            [_vModelText, _ctx.delegate.c_request_addchg_cr_zip]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "住所", -1)),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtKouzaNumber",
                            class: "form-control form-control-sm",
                            disabled: _ctx.isEditMode,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.delegate.c_request_addchg_cr_add) = $event))
                          }, null, 8, _hoisted_77), [
                            [_vModelText, _ctx.delegate.c_request_addchg_cr_add]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _cache[68] || (_cache[68] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "TEL", -1)),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtKouzaNumber",
                            class: "form-control form-control-sm",
                            disabled: _ctx.isEditMode,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_request_addchg_cr_tel) = $event))
                          }, null, 8, _hoisted_82), [
                            [_vModelText, _ctx.delegate.c_request_addchg_cr_tel]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _cache[73] || (_cache[73] = _createElementVNode("h3", null, [
                    _createElementVNode("span", { class: "badge bg-primary-400 p-2 jushoTitle" }, "新住所")
                  ], -1)),
                  _createElementVNode("div", _hoisted_85, [
                    _cache[70] || (_cache[70] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "郵便番号", -1)),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtKouzaNumber",
                            class: "form-control form-control-sm",
                            disabled: _ctx.isEditMode,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.delegate.c_request_addchg_new_zip) = $event))
                          }, null, 8, _hoisted_89), [
                            [_vModelText, _ctx.delegate.c_request_addchg_new_zip]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "住所", -1)),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtKouzaNumber",
                            class: "form-control form-control-sm",
                            disabled: _ctx.isEditMode,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.delegate.c_request_addchg_new_add) = $event))
                          }, null, 8, _hoisted_94), [
                            [_vModelText, _ctx.delegate.c_request_addchg_new_add]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _cache[72] || (_cache[72] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "TEL", -1)),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtKouzaNumber",
                            class: "form-control form-control-sm",
                            disabled: _ctx.isEditMode,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.delegate.c_request_addchg_new_tel) = $event))
                          }, null, 8, _hoisted_99), [
                            [_vModelText, _ctx.delegate.c_request_addchg_new_tel]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _cache[75] || (_cache[75] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "第一承認", -1)),
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(1),
                        disabled: ""
                      }, null, 8, _hoisted_104)
                    ]),
                    _cache[74] || (_cache[74] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_1_approval,
                            _ctx.delegate.request.c_request_1_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_106)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _cache[77] || (_cache[77] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "第二承認", -1)),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(2),
                        disabled: ""
                      }, null, 8, _hoisted_111)
                    ]),
                    _cache[76] || (_cache[76] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_2_approval,
                            _ctx.delegate.request.c_request_2_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_113)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _cache[79] || (_cache[79] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "最終承認", -1)),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(3),
                        disabled: ""
                      }, null, 8, _hoisted_118)
                    ]),
                    _cache[78] || (_cache[78] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_3_approval,
                            _ctx.delegate.request.c_request_3_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_120)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("div", _hoisted_122, [
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("table", _hoisted_124, [
                      _cache[80] || (_cache[80] = _createElementVNode("thead", { class: "bg-primary-400" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "fixhead headTsukin cwT_1" }, "使用区間"),
                          _createElementVNode("th", { class: "fixhead headTsukin cwT_2" }, "交通機関名"),
                          _createElementVNode("th", { class: "fixhead headTsukin cwT_3" }, "片道普通運賃"),
                          _createElementVNode("th", { class: "fixhead headTsukin cwT_4" }, "一ヶ月定期代")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addchgList, (item) => {
                          return (_openBlock(), _createBlock(_component_Mo_addchg_row, {
                            key: item.c_addchg_rownum!,
                            item: item,
                            isDisable: _ctx.isDisableAddchgList,
                            class: "tb_input"
                          }, null, 8, ["item", "isDisable"]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[24] || (_cache[24] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _cache[83] || (_cache[83] = _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)),
        _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => _cache[84] || (_cache[84] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[85] || (_cache[85] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _cache[86] || (_cache[86] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => _cache[87] || (_cache[87] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("button", {
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_disableConf" }, {
      title: _withCtx(() => [
        _cache[88] || (_cache[88] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDisableConf), 1)
      ]),
      body: _withCtx(() => _cache[89] || (_cache[89] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_127, [
          _createElementVNode("button", {
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.disab())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.closeModal4disableConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[90] || (_cache[90] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[91] || (_cache[91] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("button", {
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}